import React from "react";
import { ReactComponent as SomethingWentWrongSvg } from "../../dashboard/SessionPlayer/icons/something_wentwrong.svg";
import "./ErrorBoundary.scss";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="error_page_container">
        <div className="error_page_content">
          <SomethingWentWrongSvg className="error_page_illustration" />
          <div className="error_page_messages">
            <h1 className="error_page_title">Something went wrong</h1>
            <p className="error_page_description">
              An unexpected error occurred. Please try refreshing the page.
              If the problem persists, contact your administrator.
            </p>
            <div className="eb-actions">
              <button
                className="eb-btn eb-btn-primary"
                onClick={() => window.location.reload()}
              >
                Refresh page
              </button>
              <button
                className="eb-btn eb-btn-secondary"
                onClick={() => (window.location.href = "/pam/dashboard")}
              >
                Go to dashboard
              </button>
            </div>
            {process.env.NODE_ENV === "development" && this.state.error && (
              <details className="eb-details">
                <summary>Error details</summary>
                <pre>{this.state.error.toString()}</pre>
              </details>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
